import { FC } from "react"
import { Box, Container } from "@mui/material"
import { useTitle } from "@/core/hooks"
import { MyChatsTable } from "../components/myChatsTable"
import { MetabaseEmbed } from "@/modules/pr/components"
import { Metabase } from "@/modules/pr/interfaces"

interface IProps {}

export const MyChatsPage: FC<IProps> = (props) => {
  useTitle(`PR ADV - Чаты`)

  return (
    <Container maxWidth={false}>
      <MyChatsTable />
      {/* <Box height={550} mt={3}>
        <MetabaseEmbed
          type={Metabase.EmbedType.chart}
          id={882}
        />
      </Box> */}
    </Container>
  )
}
